<app-top-navbar [title]="'profiles.update_confirmation.back'| translate"
                [backLink]="['../..', 'member']" />

<div class="wrapper page-update-confirmation">

  <div class="content">
    <app-alert alertType="info"
               [withIcon]="true">
      {{ 'profiles.update_confirmation.notice' | translate }}
    </app-alert>
  </div>

  <app-loyalty-club-footer/>
</div>
